<template>
  <div class="wrapper">
    <b-navbar type="light">
      <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>
      <b-navbar-brand>
        <img class="img-fluid" :src="logo" alt />
      </b-navbar-brand>
      <b-navbar-nav id="btn-menu">
        <font-awesome-icon :icon="['fas', 'bars']" @click="drawer" />
      </b-navbar-nav>

      <span id="btn-v3">
        <b-form-checkbox @change="getV3()" v-model="checkedV3" name="check-button" switch style="margin-left: 15px;">
          Nova versão
        </b-form-checkbox>
      </span>
      <b-tooltip target="btn-v3" placement="bottom" :show.sync="showTooltip">
        Uma nova versão mais rápida e atualizada da INDECX está pronta para você experimentar! Você pode alternar de volta a qualquer momento.
      </b-tooltip>
     
      <div style="margin-top: -4px">
        <dropdownLanguage />
      </div>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav>
            <div class="options-filters mt-1 mr-4">
              <div v-if="infoIndicator.indicatorName">
                <b>{{ infoIndicator.indicatorName }}:</b>
                <span>{{
                  getIndicatorValue(infoIndicator.indicatorData)
                }}</span>
              </div>
              <div v-if="allGroups.length > 1">
                <b> {{ $t('dashboard.groupActions') }} </b>
                <span>{{ actionGroupData.name }}</span>
              </div>
              <div>
                <b>{{ $t('dashboard.metric') }}:</b>
                <span v-if="myMetric === 'nps-1-5'">
                  {{ $t('menu.navbar.nps15') }}
                </span>
                <span v-else-if="myMetric === 'ces-1-5'">
                  {{ $t('menu.filter.CES1a5') }}
                </span>
                <span v-else-if="myMetric === 'csat-1-5'">
                  {{ $t('menu.filter.CSAT1to5') }}
                </span>
                <span v-else-if="myMetric === 'csat-1-5(media)'">
                  {{ $t('menu.filter.CSAT1to5Average') }}
                </span>
                <span v-else-if="myMetric === 'csat-0-10(media)'">
                  {{ $t('menu.filter.CSAT0to10Average') }}
                </span>
                <span v-else-if="myMetric === '5-stars'">
                  {{ $t('menu.filter.review5Stars') }}
                </span>
                <span v-else-if="myMetric === 'like-dislike'">
                  {{ $t('menu.filter.likeDislike') }}
                </span>
                <span v-else>
                  {{ $t('menu.navbar.nps010') }}
                </span>
              </div>
              <div v-if="myHierarchies1 && myHierarchies1.length > 0">
                <b>{{ titleize(company.indicatorIh1) }}:</b>
                {{ setfilter1(ih1.allBranches) }}

                {{
                  myHierarchies1.length - 1 !== 0
                    ? ` + ${myHierarchies1.length - 1}`
                    : ''
                }}

                <template v-if="myHierarchies1.length > 1">
                  <span id="info-ih1">
                    <font-awesome-icon
                      :icon="['fas', 'info-circle']"
                      style="font-size: 15px; color: #c1c1c1"
                    />
                  </span>

                  <b-popover
                    target="info-ih1"
                    triggers="hover"
                    placement="right"
                  >
                    {{ returnMyIh1Name() }}
                  </b-popover>
                </template>
              </div>
              <div v-if="myHierarchies2 && myHierarchies2.length > 0">
                <b>{{ titleize(company.indicatorIh2) }}:</b>
                {{ setfilter2(ih2.allBranches) }}
                {{
                  myHierarchies2.length - 1 !== 0
                    ? ` + ${myHierarchies2.length - 1}`
                    : ''
                }}

                <template v-if="myHierarchies2.length > 1">
                  <span id="info-ih2">
                    <font-awesome-icon
                      :icon="['fas', 'info-circle']"
                      style="font-size: 15px; color: #c1c1c1"
                    />
                  </span>

                  <b-popover
                    target="info-ih2"
                    triggers="hover"
                    placement="right"
                  >
                    {{ returnMyIh2Name() }}
                  </b-popover>
                </template>
              </div>
            </div>
            <div
              v-if="this.menuPath.includes('/dashboard')"
              @click="exportPdfDashboard"
              style="margin-right: 10px; margin-top: 4px"
            >
              <div
                v-if="loadingPdf"
                class="spinner-border spinner-border-sm"
              ></div>
              <b-button
                :title="`${this.$t('menu.titleExportPdf')}`"
                variant="light"
              >
                <i class="fas fa-file-pdf" style="font-size: 1em"></i>
              </b-button>
            </div>
            <div
              @click="exportPdfReports"
              v-if="
                this.menuPath === '/reports' &&
                this.reportSelect != 'Comparativo de Ações' &&
                this.reportSelect !== 'NPS por Indicadores'
              "
            >
              <div
                v-if="loadingPdf"
                class="spinner-border spinner-border-sm"
              ></div>
              <b-button
                :title="`${this.$t('menu.titleExportPdf')}`"
                variant="light"
                style="margin-right: 10px; margin-top: 4px"
              >
                <i class="fas fa-file-pdf" style="font-size: 1em"></i>
              </b-button>
            </div>
            <div
              v-if="!menuPath.includes('/panels')"
              style="margin-right: 10px; margin-top: 4px"
            >
              <b-button
                :title="`${this.$t('menu.filter.filters')}`"
                variant="light"
                @click="asideMenu"
              >
                <i class="fas fa-filter" style="font-size: 0.8em"></i>
              </b-button>
            </div>
            <div
              v-if="userProfile.type === 'master'"
              style="margin-right: 10px; margin-top: 4px"
            >
              <router-link to="/master">
                <b-button
                  :title="`${this.$t('menu.titleMasterSettings')}`"
                  variant="light"
                >
                  <i
                    class="fas fa-users-cog"
                    id="btn-config"
                    style="font-size: 0.8em"
                  ></i>
                </b-button>
              </router-link>
            </div>
            <div
              v-if="
                userProfile.permissions.config.menu &&
                userProfile.type !== 'admin-access'
              "
              style="margin-right: 10px; margin-top: 4px"
            >
              <b-dropdown
                right
                no-caret
                variant="light"
              >
                <template v-slot:button-content>
                  <font-awesome-icon id="btn-config" icon="cog" />
                </template>
                <div v-for="(config, i) in configOptions" :key="i" :title="`${$t('menu.titleSettings')}`">
                  <b-dropdown-item
                    ><router-link
                      class="config-menu-items"
                      :to="{ path: `${config.link}` }"
                      ><i :class="config.icon"></i
                      ><span class="ml-2">{{ config.name }}</span></router-link
                    ></b-dropdown-item
                  >
                </div>
              </b-dropdown>
              
            </div>
            
            <div style="margin-right: 10px; margin-top: 4px">
              <b-dropdown
                :title="`${this.$t('menu.titleMyProfile')}`"
                right
                no-caret
                variant="light"
              >
                <template v-slot:button-content>
                  <font-awesome-icon
                    id="btn-user"
                    :icon="['fas', 'user-circle']"
                  />
                </template>
                <b-dropdown-item
                  v-b-modal="`modalUserProfile${this.userAuth._id}`"
                  >{{ this.$t('menu.profile') }}</b-dropdown-item
                >
                <b-dropdown-item @click="leaveAccount(userAuth.token)">{{
                  this.$t('menu.leave')
                }}</b-dropdown-item>
              </b-dropdown>
              <modalUserProfile :user="userAuth" />
            </div>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import JsPdf from 'jspdf';
import Html2canvas from 'html2canvas';

import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import EventBus from '../../../eventBus';
import modalUserProfile from '../../molecules/modal-user-profile';
import dropdownLanguage from '../../molecules/dropdown-country';

export default {
  name: 'Navbar',

  components: {
    modalUserProfile,
    dropdownLanguage,
  },

  data: () => ({
    logo: null,
    userAuth: null,
    loadingIh1: true,
    loadingIh2: true,
    loadingPdf: false,
    loadingActions: true,
    ih1Id: '0',
    ih2Id: '0',
    filterMenu: false,
    reportSelect: null,
    configOptions: [],
    infoIndicator: {
      indicatorName: null,
      indicatorData: null,
    },
    showTooltip: false,
    checkedV3: false,
  }),

  computed: {
    ...mapState('treatments', ['allActions']),
    ...mapState('actions', [
      'myActionId',
      'myActionName',
      'actionGroupData',
      'allGroups',
      'myActionsIds',
      'allActions',
    ]),
    ...mapFields('companies', ['company', 'myMetric']),
    ...mapState('branches', [
      'ih1',
      'ih2',
      'myIh1',
      'myIh2',
      'myHierarchies1',
      'myHierarchies2',
    ]),
    ...mapState('authentication', ['userProfile']),
    ...mapState('settings', ['shortMenu']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    menuPath() {
      return this.$route.fullPath;
    },
  },

  methods: {
    getV3() {
      const token = this.userAuth.token;
      const host = window.location.host;
      const url = (host.includes('indecx.pe')) ? `https://stg.app-indecx.com/redirect/${token}` : `https://v3.app-indecx.com/redirect/${token}`;
      window.location.href = url;
    },
    returnMyIh1Name() {
      if (this.myIh1) {
        const namesIh1 = [];
        for (let i = 0; i < this.ih1.allBranches.length; i += 1) {
          for (let j = 1; j < this.myHierarchies1.length; j += 1) {
            if (this.myHierarchies1[j] === this.ih1.allBranches[i]._id) {
              namesIh1.push(this.ih1.allBranches[i].corporate_name);
            }
          }
        }
        return namesIh1.join(', ');
      }

      return '-';
    },

    returnMyIh2Name() {
      if (this.myIh2) {
        const namesIh2 = [];
        for (let i = 0; i < this.ih2.allBranches.length; i += 1) {
          for (let j = 1; j < this.myHierarchies2.length; j += 1) {
            if (this.myHierarchies2[j] === this.ih2.allBranches[i]._id) {
              namesIh2.push(this.ih2.allBranches[i].corporate_name);
            }
          }
        }
        return namesIh2.join(', ');
      }

      return '-';
    },

    getIndicatorValue(indicatorData) {
      if (indicatorData.value) {
        return indicatorData.value;
      }
      if (indicatorData.period) {
        return indicatorData.period;
      }
      return '-';
    },

    exportPdfDashboard() {
      const groupActions = this.$store.state.actions.actionGroupData.name;
      const metric = this.$store.state.companies.myMetric;

      const indicator1Name = this.titleize(this.company.indicatorIh1);
      const indicator1Value = this.setfilter1(this.ih1.allBranches);
      let indic1NameAndValue = '';
      if (indicator1Value) {
        indic1NameAndValue = ` ${
          indicator1Name ? indicator1Name : 'Ih1:'
        }: ${indicator1Value} `;
      }

      const indicator2Name = this.titleize(this.company.indicatorIh2);
      const indicator2Value = this.setfilter2(this.ih2.listFilters);
      let indic2NameAndValue = '';
      if (indicator2Value) {
        indic2NameAndValue = ` ${
          indicator2Name ? indicator2Name : 'Ih2'
        }: ${indicator2Value} `;
      }

      const actionsNames = ` Ação: ${this.myActionName} ${
        this.myActionsIds.length > 1 ? `+${this.myActionsIds.length - 1}` : ''
      } `;

      setTimeout(() => {
        this.loadingPdf = !false;
        const minhadiv = document.getElementById('minhadiv');

        const groupAction = `${this.$t(
          'dashboard.groupActions',
        )}: ${groupActions} `;

        const dashboardMetric = ` ${this.$t('dashboard.metric')}: ${metric} `;

        let textsOnlyOneFilter = `${groupAction} ${dashboardMetric} ${indic1NameAndValue} ${indic2NameAndValue} `;

        Html2canvas(minhadiv, {
          allowTaint: true,
          scale: 2,
        }).then((canvas) => {
          if (canvas.height < 1730) {
            const imgWidth = 290;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const imageData = canvas.toDataURL('image/png');
            const pdf = new JsPdf('l', 'mm', 'a4', true);
            let splitTextAction = pdf.splitTextToSize(
              actionsNames.toString(),
              420,
            );
            const x = 5;
            let y = 8;

            if (actionsNames.length > imgHeight) {
              y += 8 + actionsNames.length / imgHeight;
            } else {
              textsOnlyOneFilter += actionsNames;
              splitTextAction = '';
            }

            pdf.addImage(
              imageData,
              'PNG',
              x,
              y,
              imgWidth,
              imgHeight,
              '',
              'FAST',
            );
            pdf.setFontSize(10.0);
            pdf.setTextColor(115, 115, 115);
            pdf.setFontType('bold');
            pdf.text(textsOnlyOneFilter, 4, 5);
            pdf.text(splitTextAction, 4, 10);
            pdf.save('Relatório-NPS.pdf');
          } else {
            const contentWidth = canvas.width;
            const contentHeight = canvas.height;
            const pageData = canvas.toDataURL('image/jpeg', 1.0);
            const pdfX = ((contentWidth + 5) / 2) * 0.75;
            const pdfY = (contentHeight + 500) * 0.75;
            const imgX = pdfX - 35;
            const imgY = (contentHeight / 2) * 0.75;
            const pdf = new JsPdf('', 'pt', [pdfX, pdfY], true);
            let splitTextAction = pdf.splitTextToSize(
              actionsNames.toString(),
              460,
            );
            const x = 20;
            let y = 30;

            if (actionsNames.length > imgX) {
              y += actionsNames.length / imgX;
            } else {
              textsOnlyOneFilter += actionsNames;
              splitTextAction = '';
            }

            pdf.addImage(pageData, 'jpeg', x, y, imgX, imgY, '', 'FAST');
            pdf.setFontSize(10.0);
            pdf.setTextColor(115, 115, 115);
            pdf.setFontType('bold');
            pdf.text(textsOnlyOneFilter, 15, 20);
            pdf.text(splitTextAction, 2, 40);
            pdf.save('Relatório-NPS.pdf');
          }
          this.loadingPdf = !true;
        });
      }, 100);
    },

    exportPdfReports() {
      const groupActions = this.$store.state.actions.actionGroupData.name;
      const metric = this.$store.state.companies.myMetric;

      setTimeout(() => {
        this.loadingPdf = !false;
        const data = document.getElementById('main-reports');
        const groupAction = `${this.$t(
          'dashboard.groupActions',
        )}: ${groupActions}`;
        const reportMetric = ` ${this.$t('dashboard.metric')}: ${metric}`;

        const text = groupAction + reportMetric;

        Html2canvas(data, {
          allowTaint: true,
          scale: 2,
        }).then((canvas) => {
          if (canvas.height < 1730) {
            const imgWidth = 290;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const imageData = canvas.toDataURL('image/png');
            const pdf = new JsPdf('l', 'mm', 'a4', true);
            const x = 5;
            const y = 8;

            pdf.addImage(
              imageData,
              'PNG',
              x,
              y,
              imgWidth,
              imgHeight,
              '',
              'FAST',
            );

            pdf.setFontSize(10.0);
            pdf.setTextColor(115, 115, 115);
            pdf.setFontType('bold');
            pdf.text(text, 5, 7);
            pdf.save(`${this.reportSelect}.pdf`);
          } else {
            const contentWidth = canvas.width;
            const contentHeight = canvas.height;
            const pageData = canvas.toDataURL('image/jpeg', 1.0);
            const pdfX = ((contentWidth - 10) / 2) * 0.75;
            const pdfY = (contentHeight + 500) * 0.75;
            const imgX = pdfX;
            const imgY = (contentHeight / 2) * 0.75;
            const pdf = new JsPdf('', 'pt', [pdfX, pdfY], true);

            pdf.addImage(pageData, 'jpeg', 0, 20, imgX, imgY, '', 'FAST');
            pdf.setFontSize(10.0);
            pdf.setTextColor(115, 115, 115);
            pdf.setFontType('bold');
            pdf.text(text, 15, 15);
            pdf.save(`${this.reportSelect}.pdf`);
          }
          this.loadingPdf = !true;
        });
      }, 100);
    },

    ...mapActions('authentication', ['logout']),
    ...mapActions('companies', ['getCompany']),
    ...mapActions('branches', [
      'listBranchesIh1',
      'listBranchesIh2',
      'setIh1',
      'setIh2',
    ]),

    drawer() {
      const $menu = document.getElementById('menu-lateral');
      // const $labelMenuIndecx = document.querySelectorAll('.label-menu-indecx');
      const $sidebarContent = document.getElementById('sidebar-content');
      if ($menu.style.width === '190px') {
        $menu.style.width = '95px';
        $sidebarContent.style.maxWidth = '95px';
        $sidebarContent.style.width = '95px';

        // $labelMenuIndecx.forEach((element) => {
        //   const span = element;
        //   span.style.display = 'none';
        // });
        this.$store.state.settings.shortMenu = true;
        EventBus.$emit('drawer', true);
      } else {
        $menu.style.width = '190px';
        $sidebarContent.style.maxWidth = 'initial';
        $sidebarContent.style.width = '190px';

        // $labelMenuIndecx.forEach((element) => {
        //   const span = element;
        //   span.style.display = 'flex';
        // });
        this.$store.state.settings.shortMenu = false;
        EventBus.$emit('drawer', false);
      }
    },

    loadAction(event) {
      this.$store.state.actions.myActionId = event.target.value;
      this.$store.state.actions.myActionName =
        event.target.options[event.target.selectedIndex].text;
    },
    loadIh1() {
      this.setIh1(this.ih1Id);
    },
    loadIh2() {
      this.setIh2(this.ih2Id);
    },
    async asideMenu() {
      this.filterMenu = !this.filterMenu;
      EventBus.$emit('aside-menu', this.filterMenu);
      EventBus.$emit('apply-indicator-value', this.infoIndicator);
    },
    titleize(text) {
      if (!text) {
        text = 'indicador 1';
      }

      const words = text.toLowerCase().split(' ');
      // eslint-disable-next-line
      for (let a = 0; a < words.length; a++) {
        const w = words[a];
        if (w) {
          words[a] = w[0].toUpperCase() + w.slice(1);
        }
      }
      return words.join(' ');
    },
    setfilter1(items) {
      if (this.myHierarchies1.length > 0) {
        const item = items.find((obj) => obj._id === this.myHierarchies1[0]);
        if (item) {
          return this.titleize(item.corporate_name);
        }
      }
      return null;
    },
    setfilter2(items) {
      if (this.myHierarchies2.length > 0) {
        const item = items.find((obj) => obj._id === this.myHierarchies2[0]);
        if (item) {
          return this.titleize(item.corporate_name);
        }
      }
      return null;
    },

    leaveAccount(token) {
      this.logout(token);
      document.title = 'IndeCX';
      const elFavicon = document.getElementById('favicon');
      if(elFavicon) {
        elFavicon.setAttribute('href', '/static/favicon-32x32.png');
      }
    }
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    const logoUrl = process.env.INDECX_FILES_BUCKET;

    this.logo = `${logoUrl}/${this.company.logo}`;

    EventBus.$on('sendSelection', (reportSelect) => {
      this.reportSelect = reportSelect;
    });

    EventBus.$on('update-indicators', (infoIndicator) => {
      this.infoIndicator.indicatorName = infoIndicator.indicatorName;
      this.infoIndicator.indicatorData = infoIndicator.indicatorData;

      this.$store.state.indicators.indicatorName = infoIndicator.indicatorName;
      this.$store.state.indicators.indicatorData.value =
        infoIndicator.indicatorData.value;
      this.$store.state.indicators.indicatorData.key =
        infoIndicator.indicatorData.key;
      this.$store.state.indicators.indicatorData.period = infoIndicator
        .indicatorData.period
        ? infoIndicator.indicatorData.period
        : null;
    });

    this.configOptions = [
      {
        link: '/settings',
        icon: 'fas fa-id-card',
        name: this.$t('menu.settings.accountData.name'),
      },
      {
        link: '/users',
        icon: 'fas fa-users',
        name: this.$t('menu.settings.users.name'),
      },
      {
        link: '/alerts-bulletins',
        icon: 'fas fa-bell',
        name: this.$t('menu.settings.alertsNewsletters.name'),
      },
      {
        link: '/branches',
        icon: 'fas fa-sitemap',
        name: this.$t('menu.settings.hierarchies.name'),
      },
      {
        link: '/profile-access',
        icon: 'fas fa-low-vision',
        name: this.$t('menu.settings.accessProfile.name'),
      },
      {
        link: '/integrations',
        icon: 'fas fa-link',
        name: this.$t('menu.settings.integrations.name'),
      },
    ];


    const isShowTooltip = localStorage.getItem('testVersionTooltip');
    if(isShowTooltip) {
      this.showTooltip = true;
      setTimeout(() => {
        this.showTooltip = false;
        localStorage.removeItem('testVersionTooltip');
      }, 8000);
    }
  },

  async mounted() {
    // let query = {
    //   companyId: this.userAuth.companyId,
    //   token: this.userAuth.token,
    //   page: 1,
    //   limit: 10
    // };

    // this.loadingActions = true;

    // query = { ...query, type: 'ih1' };

    // this.loadingIh1 = false;

    // await this.listBranchesIh1(query).then(() => {
    //   this.loadingIh1 = false;
    // });

    // query = { ...query, type: 'ih2' };

    // this.loadingIh2 = true;

    // await this.listBranchesIh2(query).then(() => {
    //   this.loadingIh2 = false;
    // });

    EventBus.$on('close-filter-menu', () => {
      this.filterMenu = false;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/placeholders.scss';

.config-menu-items {
  text-decoration: none;
  color: #000;
  display: block;
}
.btn-light {
  border-radius: 30px;
  color: #606060;
  font-size: 1.2em;

  &:focus {
    box-shadow: none;
  }
}
.wrapper {
  position: relative;
  z-index: 1039;
  .input-area {
    min-width: 200px;
  }

  border-bottom: 1px solid $gray-light;
  .img-fluid {
    height: 40px;
    @media screen and (max-width: 575px) {
      max-height: 45px;
    }
  }
  #btn-menu {
    color: #5f6368;
    font-size: 1.3em;
    @media screen and (max-width: 575px) {
      font-size: 1.1em;
    }
    cursor: pointer;
    opacity: 0.6;
    transition: all 0.1s linear;
    &:hover {
      opacity: 1;
    }
  }
  .item-menu {
    font-size: 1.25em;
    @extend %half-margin-right;
    @extend %half-margin-left;
    @media screen and (max-width: 575px) {
      font-size: 1.1em;
      margin: 0;
    }
    &:nth-of-type(2) {
      @media screen and (max-width: 575px) {
        margin-right: 0;
      }
    }
    a {
      color: #5f6368;
      opacity: 0.8;
      transition: all 0.1s linear;
      &:hover {
        opacity: 1;
      }
    }
  }
}
.options-filters {
  display: flex;
  align-items: center;
  div {
    border-left: 1px solid #ccc;
    padding: 0 8px;
    &:first-of-type {
      border: none;
    }
  }
}
</style>
<style>
.dropdown-toggle-no-caret {
  border-radius: 30px;
  color: #606060;
  font-size: 1.2em;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/navbar/index.vue